import { SmartFeedEntityDynamicElementMixin } from "%/dynamic-component-editor/mixins/smart-feed-entity-dynamic-element-mixin";
import StoryCardClickBehavior from "%/dynamic-component-editor/options/story-card-click-behavior";

export const UserMessageElementMixin = {
  extends: SmartFeedEntityDynamicElementMixin,
  computed: {
    storyHref() {
      return StoryCardClickBehavior.storyHref(
        this.links.web,
        {
          authorProfile: this.entity.authoringUserId,
          postPage: this.entity.storyId,
        },
        this.getOptionValue(StoryCardClickBehavior),
      );
    },
  },
  methods: {
    getExampleEntity() {
      return {
        "storyId": 0,
        "orgId": 0,
        "authoringUserId": 0,
        "authorName": "Demo author",
        "title": "Demo title",
        "variantParentId": 0,
        "variantType": "",
        "publishingPlatformType": "publication",
        "publishingPlatformId": 0,
        "publishingPlatformName": "Demo platform",
        "remixParentId": 0,
        "currentStoryVersionId": 0,
        "isPrivate": 0,
        "status": "active",
        "timestampCreated": 1733136252,
        "timestampUpdated": 1733156127,
        "timestampContentUpdated": 1733136252,
        "timestampPublished": 1733156127,
        "inSyndicationMarketplace": 0,
        "numLikes": 12,
        "numReports": 12,
        "popularityScore": 12,
        "voteScore": 12,
        "moderationScore": 12,
        "moderationStatus": "",
        "lastModeratorId": 0,
        "numApprovedComments": 12,
        "timestampLastComment": 12,
        "timestampEdited": 0,
        "postCommentCount": 2,
        "hashtags": [],
        "variantCount": 1,
        "likeStatus": true,
        "voteStatus": 0,
        "thumbnail": "https://inspirationprod.blob.core.windows.net/inspiration-cdn/images/image-segment-preview.png",
        "message": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam nec purus nec, ipsum dolor",
        "numReplies": 0,
        "numApprovedReplies": 10,
        "authorId": 1,
        "messageId": 1,
        "userLiked": false,
        "userUpVoted": false,
        "userDownVoted": false,
      };
    },
    getRealEntity() {
      return this.getExampleEntity();
    },
  },
};
